import React, {useMemo} from "react";
import {Route, Switch, useHistory} from "react-router-dom";
import {
    Nav,
    NavItem,
    Glyphicon,
    Panel,
} from "react-bootstrap";
import {useParams, useRouteMatch} from "react-router-dom";
import { LinkContainer } from "react-router-bootstrap";
import "moment/locale/ru";
import "../style.less";
import {useEventContext} from "../../../../context";
import {useQuery} from "../../../../react-tools";
import { getStreamMeta } from "../../../../../common/src/stream";
import EventWatchPage from "./EventWatchPage";
import StreamWatchPage from "./StreamWatchPage";
import moment from "moment";
import PanelHeading from "react-bootstrap/lib/PanelHeading";
import PanelBody from "react-bootstrap/lib/PanelBody";

const StreamSwitch = ({event}) => {
    const {url} = useRouteMatch();
    const {streamKey, type} = useParams();
    const query = useQuery();
    const history = useHistory();
    const stream = event.stream.find(stream => stream.streamKey === streamKey);
    const episodeId = null !== query.get('episode') ? parseInt(query.get('episode')) : null;
    const dayIdx = null !== query.get('day') ? parseInt(query.get('day')) : null;
    const episode = null === episodeId ? null : stream.episode.find(({id}) => id === episodeId);

    const { isStarted: isStreamStarted, isStopped: isStreamStopped } = getStreamMeta(stream);
    const streamDaysCount = moment.unix(stream.timeStop).diff(moment.unix(stream.timeStart), 'days') + 1;

    if ('live' === type && !isStreamStarted) {
        return <p style={{margin: '1em'}}>Статистика будет доступна после начала работы зала</p>
    }
    if ('record' === type && !isStreamStopped) {
        return <p style={{margin: '1em'}}>Статистика будет доступна после окончания работы зала</p>
    }

    const filterValue = useMemo(() => {
        if (episodeId) {
            return `episode_${episodeId}`;
        }
        if (dayIdx !== null && 'live' === type) {
            return `day_${dayIdx}`;
        }
        return '';
    }, [episodeId, dayIdx]);
    const handleFilterChange = (value) => {
        const [filterType, filterValue] = value.split("_");
        let path = url;
        if (filterType) {
            path += `?${filterType}=${filterValue}`;
        }
        history.push(path);
    }

    const filterOptions = [];
    if ('live' === type && streamDaysCount > 1) {
        Array.from({length: streamDaysCount}).forEach((_, i) => {
            filterOptions.push({
                value: `day_${i}`,
                label: `День ${i + 1}: ${moment.unix(stream.timeStart + 3600*24*i).format('D MMMM')}`,
            });
        })
    }
    stream.episode.forEach(({id, name_ru: name, timeStart, timeStop}) => {
        filterOptions.push({
            value: `episode_${id}`,
            label: `Эпизод: ${name} (${moment.unix(timeStart).format('D MMMM, HH:mm')} - ${moment.unix(timeStop).format('HH:mm')})`
        });
    });

    return (
        <StreamWatchPage
            event={event}
            stream={stream}
            episode={episode}
            day={dayIdx}
            type={type}
            filterOptions={filterOptions}
            filterValue={filterValue}
            onChangeFilter={handleFilterChange}
        />
    );
};

const HelpDescriptionLive = () => (
    <Panel>
        <PanelHeading><Glyphicon glyph={"question-sign"} /> <strong>Как работает статистика прямого эфира?</strong></PanelHeading>
        <PanelBody>
            <p>Прямой эфир - это всё, что происходит в зале или залах в период (дата и время), указанный в настройках меропряития. Например, если мероприятие началось 1 января в 10:00 и закончилось 3 января в 19:00, и трансляция не проводилась 2 января, то все это время считается прямым эфиром. Даже если кто-то смотрел записи 2 января, это все равно учитывается как прямой эфир. Просмотры после 3 января считаются просмотрами записей.</p>
            <p>Если, например, продолжительность всей трансляции и записанного контента составляет 60 минут, и кто-то начал смотреть через 10 минут до окончания трансляции и вернулся к началу, но закончил просмотр после окончания трансляции, то его просмотр будет учитываться как просмотр прямого эфира и записей. Рекомендуем установить продолжительность работы зала на 1-2 часа дольше, чем фактическая длительность мероприятия.</p>
            <p>Сбор статистики начинается с момента начала трансляции в плеере, и продолжительность просмотра - это общее время, которое люди провели, смотря контент в зале или залах. Например, если трансляция длится 60 минут, и кто-то сначала смотрит 10 минут, потом выходит, а затем возвращает и смотрит еще 10 минут до конца, то его просмотр будет учтен только как 10 минут, или 16% от всей продолжительности трансляции.</p>
        </PanelBody>
    </Panel>
)
const HelpDescriptionRecord = () => (
    <Panel>
        <PanelHeading><Glyphicon glyph={"question-sign"} /> <strong>Как работает статистика просмотра записей?</strong></PanelHeading>
        <PanelBody>
            <p>Статистика просмотра записей означает информацию, которая собирается, когда кто-то смотрит часть видеозаписи после того, как закончилась трансляция в зале или всё мероприятие целиком, т.е. закончился период, указанный в настройках меропряития.</p>
            <p>Продолжительность просмотра - это просто общее время, в течение которого кто-то смотрит видеозапись.<br />Например, если запись длится 60 минут, и кто-то смотрел первые 10 минут четыре раза подряд, перематывая ее, то его просмотр будет засчитан как только 10 минут из 60, что составляет 16% от всей продолжительности записи.</p>
        </PanelBody>
    </Panel>
)

export default () => {
    const {event} = useEventContext();
    const {path, url} = useRouteMatch();
    const {type} = useParams();

    const title = type === 'live' ? 'Статистика прямого эфира' : 'Статистика просмотра записей';

    return (
        <>
            <h3 style={{whiteSpace: 'pre'}}>{title}: {event.name_ru}</h3>
            {'live' === type
                ? <HelpDescriptionLive />
                : <HelpDescriptionRecord />
            }
            {event.stream.length > 1 &&
            <Nav bsStyle="tabs">
                <LinkContainer to={url} exact>
                    <NavItem>Сводная</NavItem>
                </LinkContainer>
                {event.stream.map(({id, streamKey, description_ru}) => (
                    <LinkContainer to={`${url}/${streamKey}`} key={streamKey}>
                        <NavItem>{description_ru || `Зал №${id}`}</NavItem>
                    </LinkContainer>
                ))}
            </Nav>}
            <Switch>
                <Route path={`${path}/:streamKey`}>
                    <StreamSwitch event={event} />
                </Route>
                <Route path={`${path}`} exact>
                    <EventWatchPage event={event} type={type} />
                </Route>
            </Switch>
        </>
    );
};
